import { FunctionComponent } from 'react';

export enum FilterType {
  NUMBER = 'number',
  STRING = 'string',
  DATE = 'date'
}

export type SelectArray = {
  id: string;
  text: string;
};

export type propertyType = {
  propName: string;
  value: string | Date | 'select' | null | boolean;
  type: string;
};

export type SearchProps = {
  filterColumn?: DatableColumnType[];
  searchFunction: Function;
  searchValue: string;
  propSearch: propertyType[] | [];
  setPropSearch: Function;
};


export type DatableColumnType = {
  name?: string;
  id?: string;
  label: string;
  align?: 'right' | 'left' | 'center';
  datatype?: 'string' | 'date' | 'select' | 'boolean' | 'number' | 'custom';
  selectArray?: SelectArray[];
  padding?: 'none' | 'normal';
  searchable?: boolean | false;
  orderable?: boolean | false;
  visible?: boolean | false;
  isSorted?: boolean;
  Render?: FunctionComponent<{ data: any; row: any; isHighlighted?: boolean }>;
};


export interface EnhancedTableProps {
  numSelected: number;
  onRequestSort: (event: React.MouseEvent<unknown>, property: string) => void;
  order: 'asc' | 'desc';
  orderBy: string;
  rowCount: number;
  autoIndex?: boolean;
  columns: DatableColumnType[];
}

export interface EnhancedTableToolbarProps {
  FilterComponent?: React.ComponentType<any>;
  filterColumn?: DatableColumnType[];
  searchFunction: Function;
  searchValue: string;
  propSearch: object[];
  setPropSearch: Function;
  btnAction?: VoidFunction;
  btnText?: string;
  onClearFitler?: () => void;
}

export interface TableBodyPropType {
  loading: boolean;
  tableData: any;
  columns: DatableColumnType[];
  page: number;
  rowsPerPage: number;
  autoIndex: boolean;
  isDisabledTbLoading?: boolean;
  onClickRow?: (row: any, event?: React.MouseEvent) => void;
  highlightedRowId?: string | null;
}

export interface AsyncDataTablePropsType {
  dataUrl: string;
  columns: DatableColumnType[];
  label?: string;
  hideFilter?: boolean;
  hideHeader?: boolean;
  FilterComponent?: React.ComponentType<any>;
  refreshPage: boolean;
  debounceTime?: number;
  orderByDef?: string;
  orderDef?: 'asc' | 'desc';
  autoIndex?: boolean;
  mockData?: any;
  btnAction?: VoidFunction;
  btnText?: string;
  isDisabledTbLoading?: boolean;
  defaultFilterProp?: propertyType[];
  defaultFilterVals?: propertyType[];
  fetchSize?: number;
  onFilterChange?: (filters: propertyType[]) => void;
  // New header props
  showPageHeader?: boolean;
  pageTitle?: string;
  pageSubtitle?: string;
  headerAction?: VoidFunction;
  headerActionText?: string;
  headerActionIcon?: React.ReactNode;
  onClickRow?: (row: any, event?: React.MouseEvent) => void;
  onClearFitler?: () => void;
  // Caching props
  cacheKey?: string;
  // Highlighting props
  highlightedRowId?: string | null;
}
